import { Platform } from 'react-native';
import * as SecureStore from 'expo-secure-store';

/**
 * Platform-agnostic storage utility
 * Uses SecureStore for native platforms and localStorage for web
 */
const storage = {
  /**
   * Save a value
   * @param {string} key - Storage key
   * @param {string} value - Value to store
   */
  setItem: async (key, value) => {
    if (Platform.OS === 'web') {
      localStorage.setItem(key, value);
    } else {
      await SecureStore.setItemAsync(key, value);
    }
  },

  /**
   * Retrieve a value
   * @param {string} key - Storage key
   * @returns {Promise<string|null>} Stored value or null
   */
  getItem: async (key) => {
    if (Platform.OS === 'web') {
      return localStorage.getItem(key);
    } else {
      return await SecureStore.getItemAsync(key);
    }
  },

  /**
   * Delete a value
   * @param {string} key - Storage key
   */
  deleteItem: async (key) => {
    if (Platform.OS === 'web') {
      localStorage.removeItem(key);
    } else {
      await SecureStore.deleteItemAsync(key);
    }
  },
};

export default storage;
